import classNames from "classnames/bind";
import styles from "./HeaderOnly.module.scss";
// import Header from "./Header";
import Footer from "../components/Footer/Footer";
import MenuMobile from "../../pages/components/MenuMobile/MenuMobile";
const css = classNames.bind(styles);

function HeaderOnly({ children }: { children: any }): JSX.Element {
  return (
    <div className={css("wrapper")}>
      {/* <Header /> */}
      <MenuMobile />
      <div className={css("container")}>{children}</div>
      <Footer />
    </div>
  );
}

export default HeaderOnly;
